import api from '@/apis/di/accountAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Tài khoản nợ, có
export const useAccountAutoBusinessCustomComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo từ danh sách tài khoản chi tiết nhất, riêng với tk 006, 008, 009 load lên tk chi tiết nhất và cha liền kề nó
  const onAccountAutoBusinessComboboxLoadDataCustom = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let orsIsParent = [{ Field: 'is_parent', Operator: 'NULL' }];
    let ors2 = [{ Field: 'is_parent', Value: false, Ors: orsIsParent }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      {
        Field: 'account_number',
        Operator: 'IN',
        Value: [
          '0041',
          '0042',
          '0061',
          '0062',
          '00811',
          '00812',
          '00813',
          '00821',
          '00822',
          '00823',
          '0091',
          '0092',
          '0093',
        ],
        Ors: ors2,
      },
    ];

    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'account_number';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const accountAutoBusinessComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      { title: 'Tên tài khoản', dataField: 'account_name', filterOperator: proxy.$ms.constant.FilterOperator.Contains, width: 480 },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onAccountAutoBusinessComboboxLoadDataCustom,
  };

  return {
    accountAutoBusinessComboConfig,
    onAccountAutoBusinessComboboxLoadDataCustom,
  };
};
